export default __webpack_public_path__ + "static/media/barapole.640ddd0d.jpg";